import React, {Component} from 'react';
import {connect} from 'react-redux';
import {NotificationContainer} from 'react-notifications';
import AuthorizationAction from '../actions/AuthorizationAction';
import logo from '../image/logo.png';

class App extends Component {
  state = {
    isMenuShow: ''
  };

  openMenu() {
    if (this.state.isMenuShow === 'active') {
      this.setState({isMenuShow: ''});
    } else {
      this.setState({isMenuShow: 'active'});
    }
  }

  get headerItems() {
    if (!this.props.user.isAuthenticated) {
      return (
        <nav className="navbar-default outer-panel">
          <div className="container-fluid">
            <div className="logo-box">
              <a href="/" className="text-logo"><img src={logo} alt="Rifird" height="40"/></a>
              <div className="text">Spread the Love</div>
            </div>
          </div>
          {/* /.container-fluid */}
        </nav>);
    } else {
        return (
        <nav className="navbar navbar-default  navbar-fixed-top">
          <div className="container-fluid">
            <div className="navbar-collapse" id="bs-example-navbar-collapse-1">
              <div className="logo-block">
                <button className="menu-button" onClick={this.openMenu.bind(this)}>
                  <i className={this.state.isMenuShow === 'active' ? 'fa fa-times' : 'fa fa-bars'}
                     aria-hidden="true"></i>
                </button>
                <a href="/" className="text-logo"><img src={logo} alt="Rifird" height="40"/></a>
              </div>
            </div>
            {/* /.navbar-collapse */}
          </div>
          {/* /.container-fluid */}
        </nav>
      )
    }
  }

  get leftMenu() {
    var location = this.props.location.pathname.replace('/', '');
    if (this.props.user.isAuthenticated) {
      return (
        <div id="sidebar-wrapper" className={this.state.isMenuShow}>
          <div className="sidebar-nav">
            <ul className="left-menu" style={{marginBottom: '100px'}}>
              <li className="title-menu">
                Main
              </li>
              <li className={location === '' ? 'active' : ''}>
                <a href="/#/">
                  <i className="fa fa-bar-chart" aria-hidden="true"></i> Dashboard
                </a>
              </li>
              <li className={location === 'customers' ? 'active' : ''}>
                <a href="/#/customers">
                  <i className="fa fa-users" aria-hidden="true"></i> Customers
                </a>
              </li>
              <li className={location === 'perks' ? 'active' : ''}>
                <a href="/#/perks">
                  <i className="fa fa-list-alt" aria-hidden="true"></i> Perks
                </a>
              </li>
            </ul>
            <ul className="left-menu">
              <li className="title-menu">
                Account
              </li>
              <li className={location === 'profile' ? 'active' : ''}>
                <a href="/#/profile">
                  <i className="fa fa-user-circle-o" aria-hidden="true"></i> User Profile
                </a>
              </li>
              <li className={location === 'merchant_info' ? 'active' : ''}>
                <a href="/#/merchant_info">
                  <i className="fa fa-building" aria-hidden="true"></i> Merchant
                </a>
              </li>
              <li>
                <a onClick={() => this.props.logout()}>
                  <i className="fa fa-sign-out" aria-hidden="true"></i> Logout
                </a>
              </li>
            </ul>
          </div>
        </div>)
    } else {
      return (
        <div></div>
      )
    }
  }

  render() {
    return (
      <div>
        {this.headerItems}
        <div id="wrapper">
          {this.leftMenu}
          {this.props.children}
        </div>
        <NotificationContainer />
      </div>
    )
  }
}

export default connect(
  state => ({
    user: state.user
  }),
  dispatch => ({
    logout: () => dispatch(AuthorizationAction.logoutUser())
  })
)(App);


/** WEBPACK FOOTER **
 ** ./src/containers/App.js
 **/